import React from "react";

import { Space, Switch } from "antd";

function Filters(props) {
  const { filters } = props;
  const isActive = filters ? filters.active == 1 : false;

  return (
    <>
      <Space size="small">
        <Switch
          checked={isActive}
          size="small"
          onChange={(bool) => props.onUpdateFilters({ active: bool ? 1 : 0 })}
        />{" "}
        Actives
      </Space>
    </>
  );
}

Filters.defaultProps = {
  filters: {},
  onUpdateFilters: async () => {},
};

export default Filters;
